import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { postBrandStoreChargeDiscount } from "../../../services/ChargeDiscount.js/chargeDiscount";
import SuccessModal from "../../SuccessModal";

const ChargesAndDiscountAddModal = ({
  chargesAndDiscountModalVisible,
  setChargesAndDiscountModalVisible,
  sendDataToStoreConfig,
  selectedChargeAndDiscountValue,
  brandId,
  storeId,
  chargesAndDiscountSelected
}) => {
  const OrderStatus = selectedChargeAndDiscountValue;

  const chargesAndDiscountSelectedList = chargesAndDiscountSelected;

  // Create a Set of IDs already present in warehouseStoreDataList
  const existingIds = new Set(
    chargesAndDiscountSelectedList?.map(item => item?.chargeDiscount.id)
  );

  // Keep only items that are NOT already present
  const filteredData = OrderStatus?.filter(
    item => !existingIds.has(item.id)
  );

  const [selectedStatus, setSelectedStatus] = useState([]);
     const [modalVisible, setModalVisible] = useState(false);
     const [modalStatus, setModalStatus] = useState(false);
     const [modalText, setModalText] = useState('');

  const handleStatusToggle = status => {
    const updatedStatus = [status];
    setSelectedStatus(updatedStatus);
  };
  const handleConfirmPickup = () => {
    
    const updatedData = {
      chargeDiscount: {...selectedStatus[0]},
      storeId: storeId,
    };
    postBrandStoreChargeDiscount(brandId, updatedData)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
           if (Res) {
             const message = Res.message;
             const status = Res.status;
             setChargesAndDiscountModalVisible(false);
             sendDataToStoreConfig({
               success: true,
             });
             if (status === true) {
               setModalVisible(true);
               setModalStatus('success');
               setModalText(message);
              } else if (message === 'Already exist!') {
                setModalVisible(true);
                setModalStatus('not Success');
                setModalText(message);
              } else {
                setModalVisible(true);
                setModalStatus('not Success');
                setModalText(message);
              }
              setSelectedStatus([]);
           }
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };
  const handleModalClose = () => {
    setChargesAndDiscountModalVisible(false);
    setSelectedStatus([]);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={  chargesAndDiscountModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!  chargesAndDiscountModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"images/plus.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                ADD {filteredData?.[0]?.chargeDiscountType}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
            <div className="mx-4">
              {filteredData?.length > 0 ? (
                filteredData?.filter(item => item.status).map((item) => (
                  <div
                    key={item.id}
                    className="flex flex-1 justify-content-between my-1"
                  >
                    
                    <p className="text-xl font-medium">{item.name}</p>
                    <div>
                      <Checkbox
                        checked={selectedStatus.includes(item)}
                        size="20" // Increased size
                        color={
                          selectedStatus.includes(item)
                            ? "#00A3FF"
                            : "#C1C9D3"
                        }
                        onClick={() => handleStatusToggle(item)}
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="text-xl font-medium">No {filteredData?.[0]?.chargeDiscountType} Found</p>
                </div>
              )}
            </div>
            </div>

            {filteredData?.length !== 0 && (
            <Button
              onClick={handleConfirmPickup}
              className="mt-1 mb-3 mx-4 border-round-xl "
              disabled={selectedStatus?.length <= 0 && true}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                ADD
              </p>
            </Button>
            )}
          </div>
        )}
      ></Dialog>
       <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default ChargesAndDiscountAddModal;
